import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import {
  CheckboxModule,
  FormControlModule,
  LoaderModule,
} from '@northfork/ng-basics'
import { MvtCheckboxControlComponent } from './mvt-checkbox-control.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CheckboxModule,
    FormControlModule,
    LoaderModule,
  ],
  declarations: [MvtCheckboxControlComponent],
  exports: [MvtCheckboxControlComponent],
})
export class MvtCheckboxControlModule {}
